import React from 'react';
import styled from '@emotion/styled';

import { naturalSortByName } from '../utils/NaturalSort';
import { useSearchParams } from '../search_params';
import { Icon } from '../lumen';
import { Dropdown } from './Dropdown';

export const ActiveFilters = () => {
  const { searchParams } = useSearchParams();
  const filters = [...(searchParams.filter ?? [])].sort(naturalSortByName);

  if (filters.length === 0) {
    return null;
  }

  return (
    <Dropdown
      align="right"
      trigger={
        <TriggerButton type="button" aria-label="Show applied filters">
          <Icon name="filter" size={16} />
          Filters ({filters.length})
        </TriggerButton>
      }
    >
      <FilterList>
        {filters.map(constraint => (
          <FilterRow key={constraint.name}>
            <Icon name="filter" size={16} />
            <span>{constraint.toString()}</span>
          </FilterRow>
        ))}
      </FilterList>
    </Dropdown>
  );
};

const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px;
  background: ${({ theme }) => theme.color.bg.default};
  border: 1px solid ${({ theme }) => theme.color.slate[300]};
  border-radius: ${({ theme }) => theme.radius.base};
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.sans};
  font-size: 14px;
  color: ${({ theme }) => theme.color.fg.default};
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.color.primary.base};
    color: ${({ theme }) => theme.color.primary.base};
  }

  & > svg {
    color: ${({ theme }) => theme.color.fg.muted};
  }

  &:hover > svg {
    color: currentColor;
  }
`;

const FilterList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 320px;
  max-height: 40vh;
  overflow-y: auto;
  padding: 12px;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: ${({ theme }) => theme.font.sans};
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.color.fg.default};

  & > svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: ${({ theme }) => theme.color.fg.muted};
  }
`;
